import React, { useContext, useEffect } from 'react';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';
import { UserDetailsContext } from 'context/userDetailsContext';
import { convertCaseToFilterFormat } from 'utils/utils';

function CaseFilter() {
  const { fileManagerFilters, onFilterChange, isClientFileManager, setBreadCrumbs, setSelectedRows } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  function clearBreadcrumbs() {
    setBreadCrumbs([]);
  }

  useEffect(() => {
    if (isClientFileManager && userContext?.clientSelectedCase) {
      onFilterChange(
        {
          target: {
            name: 'case',
            value: convertCaseToFilterFormat(userContext?.clientSelectedCase) || '',
          },
          value: convertCaseToFilterFormat(userContext?.clientSelectedCase) || '',
        },
        setBreadCrumbs
      );
    }
  }, [userContext?.clientSelectedCase]);

  return (
    <div className="filter-wraper">
      {isClientFileManager && userContext?.clientCaseList.length > 1 && (
        <CaseListDropDown
          isClient={isClientFileManager}
          value={fileManagerFilters?.case}
          onChange={(e) => {
            if (fileManagerFilters?.case !== e) {
              onFilterChange({ target: { name: 'case', value: e }, value: e }, clearBreadcrumbs);
              setSelectedRows([]);
            }
          }}
          name="case"
          selectFirstOption
          excludeFromLoading={true}
        />
      )}
      {!isClientFileManager && (
        <CaseListDropDown
          isClient={isClientFileManager}
          placeholder="By Case/Lead"
          value={fileManagerFilters?.case}
          onChange={(e) => {
            if (fileManagerFilters?.case !== e) {
              onFilterChange({ target: { name: 'case', value: e }, value: e }, clearBreadcrumbs);
              setSelectedRows([]);
            }
          }}
          noOptionsMessage="No Cases/Leads Found"
          name="case"
          isClearable
          excludeFromLoading={true}
        />
      )}
    </div>
  );
}

export default CaseFilter;
